import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";

const steps = [
  { label: "Select File" },
  { label: "Processing" },
  { label: "Import" },
  { label: "Save Fields" },
];

const Stepper = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [saveStep, setSaveStep] = useState("Select File");

  const handleStepClick = (stepIndex) => {
    setCurrentStep(stepIndex);
  };

  return (
    <div className="flex items-center justify-center gap-4">
      {steps.map((step, index) => (
        <div key={index} className="flex items-center gap-2">
          <div
            onClick={() => handleStepClick(index)}
            className={`flex items-center cursor-pointer gap-2`}
          >
            <span
              className={`${
                currentStep === index ? "text-green-500" : "text-gray-400"
              } font-semibold text-sm`}
              onClick={() => setSaveStep(step.label)}
            >
              {saveStep}
            </span>
          </div>
          {index < steps.length - 1 && (
            <FaArrowRight className="text-gray-500" />
          )}
        </div>
      ))}
    </div>
  );
};

export default Stepper;
